import Client from './client';

export default class ShopifyCarts extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  putShopifyAndCartsAndPromotionById(id, options = {}) {
    return this.makeRequest(`${this.host}/shopify/carts/${id}/promotion`, {
      ...options,
       method: 'PUT',
    });
  }

  deleteShopifyAndCartsAndPromotionById(id, options = {}) {
    return this.makeRequest(`${this.host}/shopify/carts/${id}/promotion`, {
      ...options,
       method: 'DELETE',
    });
  }

  postShopifyAndCartsAndFlowAndOrderByOrganization(organization, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/shopify/carts/flow/order`, {
      ...options,
       method: 'POST',
    });
  }

}
